import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import HorizontalBarChart from "../../../ceo/analysis/competitive/charts/horizontal-bar";
import TypeformContent from "../../../typeform/TypeformContent";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";

class TeamReportsSection2Step3 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    let val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get SharePrice() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Share Price")
      });
    });

    return data;
  }

  get left_content() {
    const { share_price } = this.props;

    return (
      <span>
        Share Price is synonymous with the term stock price. It represents the
        price an investor will pay to own 1 share of a company. The higher the
        growth rate in the share price, the better.
        <br />
        <br />
        At the start of the competition, all teams started out with a share
        price of ${share_price.toFixed(2)}. Here's the formula for Share Price.
        <br />
        <br />
        <div className="formula">
          SHARE PRICE =
          <div className="formula">
            YOUR BUSINESS VALUE
            <hr />
            SHARES OUTSTANDING
          </div>
        </div>
        <br />
        <br />
        To learn more about what drives your share price, please review the
        following content:
        <br />
        <TypeformLink title="Share Price" url={TypeformUrls.STOCK_PRICE} />
        <TypeformLink
          title="Business Valuation"
          url={TypeformUrls.BUSINESS_VALUATION}
          className="link-with-margin"
        />
        <TypeformLink
          title="Shares Outstanding"
          url={TypeformUrls.SHARES_OUTSTANDING}
          className="link-with-margin"
        />
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <HorizontalBarChart prefix="$" data={this.SharePrice} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Share Price
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="xs"
            {...TypeformContent.STOCK_PRICE}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Share Price"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step3;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-3.js